import React from 'react'
import PropTypes from 'prop-types'
import { DriverKeyTableHead } from '../components/Table/data'
import BodyContainer from '../components/bodyContainer'

const ConfigurationDriver = ({
  fetchData,
  success,
  pageLimitChanged,
  pageChanged,
  onCloseReset,
  isLoadingDriverList,
  drivers,
  driverCount,
  searchData,
  errorMessage,
  removeError,
  isErrorFetch,
  isSuccessRefresh,
  resetSuccessAction,
}) => {
  return (
    <BodyContainer
      //EtatdisplayMode
      isDisplayMode={false}
      //TableMode
      actionButton={true}
      tableHead={DriverKeyTableHead}
      //Commonfields
      globalID={'DriverKeys'}
      searchPlaceholder={'Rechercher par chauffeur'}
      title={'Association Clés-Chauffeur'}
      fetchData={fetchData}
      loadingData={isLoadingDriverList}
      dataList={drivers}
      countData={driverCount}
      errorMessage={errorMessage}
      removeError={removeError}
      removeErrorConfig={() => {}}
      isErrorFetch={isErrorFetch}
      pageLimitChanged={pageLimitChanged}
      pageChanged={pageChanged}
      searchData={searchData}
      onCloseReset={onCloseReset}
      resetSuccessAction={resetSuccessAction}
      success={success}
      isSuccessRefresh={isSuccessRefresh}
      isDriverKey={true}
    />
  )
}
ConfigurationDriver.propTypes = {
  drivers: PropTypes.array,
  fetchData: PropTypes.func,
  isLoadingDriverList: PropTypes.bool,
  pageLimitChanged: PropTypes.func,
  pageChanged: PropTypes.func,
  searchKeys: PropTypes.func,
  onCloseReset: PropTypes.func,
  searchData: PropTypes.func,
  success: PropTypes.bool,
  driverCount: PropTypes.number,
  errorMessage: PropTypes.string,
  removeError: PropTypes.func,
  isErrorFetch: PropTypes.bool,
  isSuccessRefresh: PropTypes.bool,
  resetSuccessAction: PropTypes.func,
}
export default ConfigurationDriver
